module.exports = __webpack_public_path__ + "static/media/event.74ce63e2.jpg";